module.exports = __webpack_public_path__ + "static/media/Gandhinagar.418c6b19.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/backs/Gandhinagar.jpg
// module id = 905
// module chunks = 0